module.exports = function getResource(label) {
    let resources = {
        onlyAFewLeft: 'only a few left'
    };
    return resources[label];
};
